import { FormModel_scopeItems, mapItemScopeFromBE, mapItemScopeToBE } from '@prisma/containers/model/scope.models';
import { _isDev, _isFeDev, _log, _warn } from '@shared/aux_helper_environment';
import { _array2plainId, _cloneDeep, _get, _pick, _reset_getNewNumberId } from '@shared/aux_helper_functions';
import {
  DEFAULT_INTERNAL_CODE_PROP,
  DEFAULT_INTERNAL_UOM_PROP,
  _auxReduceProdsStoresInfo,
  _clonePlanogram,
  _round,
  _set_internalItemId,
} from './spaces_aux_helpers';

const SHELF_ID_PREFIX = '_SH-'; //Se concatena este prefijo para evitar colisiones
export const MOD_ID_PREFIX = '_MOD-'; //Se concatena este prefijo para evitar colisiones
const PROD_ID_PREFIX = '_PRD-'; //Se concatena este prefijo para evitar colisiones
const PROD_POP_ID_PREFIX = '_PRDPOP-'; //Se concatena este prefijo para evitar colisiones
const FLOAT_ID_PREFIX = '_FLOAT-'; //Se concatena este prefijo para evitar colisiones
const TEST_PRICE_ZERO = false && _isDev();

export {
  _applyExhibitionFormatToItemData,
  _prepareProdItemDataForExhibitionDrop,
  _resolveActiveExhibitionTypeId,
} from './spaces_aux_exhibition_format';

import { _applyExhibitionFormatToItemData, _resolveActiveExhibitionTypeId } from './spaces_aux_exhibition_format';

/*
    Trasnformaciones para load
    INPUT
*/

const _addInternalObjId = (_obj, _ID) => {
  if (_obj?.id == null) return;
  _obj.id = _ID + String(_obj.id).replace(_ID, '');
};

//DES-2097 / Codigo para imresión de planogramas
const _addInternalCode = _objMetadata => {
  if (_objMetadata == null) return;

  let key = DEFAULT_INTERNAL_CODE_PROP;
  let keyUom = DEFAULT_INTERNAL_UOM_PROP;

  let _internalCode = _objMetadata?.[key]; // _obj?.code ?? _obj?.ean;
  let _internalUom = _objMetadata?.[keyUom];
  if (false) _log('[_addInternalCode]', key, _objMetadata?.[key], _internalCode, _internalUom);

  if (_isFeDev() && _internalCode && false) {
    _internalCode = 'ICode:' + _internalCode;
  }

  if (_internalCode != null || _internalUom != null) {
    _objMetadata._internalCode = _internalCode;
    _objMetadata._internalCodeUom = _internalCode + '-' + _internalUom;
  } else {
    console.warn('_auxTransformOutputData_prodTransform: No se puede agregar el codigo interno porque no existe el codigo', _objMetadata);
  }

  //CAT-19
  let isFixedEmptySpace = _objMetadata?.code === 'FixedEmptySpace' || Number(_objMetadata?.itemId) === -2;
  let isEmptySpace =
    _objMetadata?.code === 'EmptySpace' ||
    _objMetadata?.code === 'FixedEmptySpace' ||
    Number(_objMetadata?.itemId) === -1 ||
    isFixedEmptySpace;

  // Si BE no envía code para espacios vacíos, lo inferimos por itemId.
  if (!_objMetadata?.code && isEmptySpace) {
    _objMetadata.code = isFixedEmptySpace ? 'FixedEmptySpace' : 'EmptySpace';
  }
  if (isEmptySpace) {
    _objMetadata.name = isFixedEmptySpace ? 'Espacio vacío fijo' : 'Espacio vacío';
    _objMetadata.canRotate = false;
    _objMetadata.canRotateY = false;
  }
  _objMetadata.isEmptySpace = isEmptySpace;
  _objMetadata.isFixedEmptySpace = isFixedEmptySpace;
};

export const _removeInternalObjId = (_obj, _ID) => {
  if (_obj?.id == null) return;
  if (String(_obj.id).includes(_ID)) _obj.id = _obj.id.replace(_ID, '');
  if (_obj.id == Number(_obj.id)) _obj.id = Number(_obj.id);
  return _obj.id;
};

const _lineItemRichness = (p: any): number => {
  if (!p) return 0;
  const data = p.itemData || p;
  const sizeW = data?.size?.w ?? data?.width ?? p?.width;
  if (sizeW > 0 && (data?.itemId != null || p?.itemId != null)) return 3;
  if (data?.itemId != null || p?.itemId != null) return 2;
  if (p?.metrics || p?.tagValueIds?.length) return 1;
  return 0;
};

const _lineItemKey = (p: any, idx: number): string =>
  `${p?.order ?? idx}|${p?.itemId ?? p?.itemData?.itemId ?? ''}|${p?.unitOfMeasureId ?? p?.itemData?.unitOfMeasureId ?? ''}`;

/**
 * Preview S16 expone `shelfs[].items[]`; el editor histórico usa `shelfs[].prods[]`.
 * Une ambos tomando el registro más completo por SKU (p. ej. items con métricas + prods con itemData).
 */
export const _mergeShelfLineItemsForTransform = (shelf: { prods?: any[]; items?: any[] }): any[] => {
  const items = shelf?.items || [];
  const prods = shelf?.prods || [];
  if (!items.length) return prods;
  if (!prods.length) return items;

  const map = new Map<string, any>();
  const put = (p: any, idx: number) => {
    if (!p) return;
    const k = _lineItemKey(p, idx);
    const prev = map.get(k);
    if (!prev || _lineItemRichness(p) > _lineItemRichness(prev)) {
      map.set(k, p);
    }
  };
  prods.forEach((p, i) => put(p, i));
  items.forEach((p, i) => put(p, i));

  return [...map.values()].sort((a, b) => (a?.order ?? 0) - (b?.order ?? 0));
};

/** @deprecated alias — usar _mergeShelfLineItemsForTransform */
export const _getShelfLineItemsForTransform = _mergeShelfLineItemsForTransform;

/** Asegura itemData + size para ítems planos del preview (S16) antes del filtro del canvas. */
export const _normalizePreviewLineItemForTransform = ($prod: any): any => {
  if (!$prod) return $prod;

  const prod = $prod;
  const rootItemId = prod.itemId ?? prod.itemData?.itemId;
  const rootUom = prod.unitOfMeasureId ?? prod.itemData?.unitOfMeasureId;

  if (!prod.itemData) {
    prod.itemData = {
      itemId: rootItemId,
      unitOfMeasureId: rootUom,
      name: prod.name,
      code: prod.code,
      width: prod.width,
      height: prod.height,
      depth: prod.depth,
      imagePlanogramFront: prod.imagePlanogramFront,
      imagePlanogramLateral: prod.imagePlanogramLateral,
      imagePlanogramTop: prod.imagePlanogramTop,
      isEmptySpace: prod.isEmptySpace,
      isListed: prod.isListed,
      storesInfo: prod.storesInfo,
      tags: prod.tags,
    };
  }

  const data = prod.itemData;
  if (data.itemId == null && rootItemId != null) data.itemId = rootItemId;
  if (data.unitOfMeasureId == null && rootUom != null) data.unitOfMeasureId = rootUom;
  if (data.name == null && prod.name != null) data.name = prod.name;
  if (data.code == null && prod.code != null) data.code = prod.code;
  if (data.width == null && prod.width != null) data.width = prod.width;
  if (data.height == null && prod.height != null) data.height = prod.height;
  if (data.depth == null && prod.depth != null) data.depth = prod.depth;
  if (data.imagePlanogramFront == null && prod.imagePlanogramFront != null) {
    data.imagePlanogramFront = prod.imagePlanogramFront;
  }

  data.size = data.size || {};
  if (data.size.w == null) data.size.w = data.width ?? prod.width;
  if (data.size.h == null) data.size.h = data.height ?? prod.height;
  if (data.size.d == null) data.size.d = data.depth ?? prod.depth ?? data.size.w;

  if (data.code === 'EmptySpace' || rootItemId === -1 || data.itemId === -1) {
    data.isEmptySpace = true;
    if (data.itemId == null) data.itemId = -1;
    if (!(data.size.w > 0)) data.size.w = 1;
    if (!(data.size.h > 0)) data.size.h = 1;
  }

  return prod;
};

export const _isRenderablePreviewLineItem = (p: any): boolean => {
  if (!p?.itemData) return false;
  const itemId = p.itemData.itemId ?? p.itemId;
  if (itemId == null) return false;
  const sizeW = p.itemData.size?.w ?? p.itemData.width ?? p.width;
  return !!(sizeW > 0);
};

export const _auxTransformInputPlanogramData = ($planogram, featureFlagScope) => {
  let obj = _cloneDeep($planogram);

  obj.modules = (obj.modules || [])
    .sort((x, y) => {
      if (x.order == null || x.order === y.order) return 0;
      return x.order < y.order ? -1 : 1;
    })
    .map(mod => {
      mod.shelfs = (mod.shelfs || [])
        .sort((x, y) => {
          if (x.order == null || x.order === y.order) return 0;
          return x.order < y.order ? -1 : 1;
        })
        .map(shelf => {
          shelf.prods = _mergeShelfLineItemsForTransform(shelf)
            .map($prod => _normalizePreviewLineItemForTransform(_cloneDeep($prod)))
            .filter(_isRenderablePreviewLineItem)
            .sort((x, y) => {
              if (x.order == null || x.order === y.order) return 0;
              return x.order < y.order ? -1 : 1;
            })
            .map($prod => {
              let prod = $prod;

              prod.itemData._internalItemId = _set_internalItemId(prod.itemData.itemId, prod.itemData.unitOfMeasureId);

              // Si el producto tiene unitOfExhibition, usar esos datos en lugar de itemData
              if (prod.unitOfExhibition) {
                // Preservar imagen individual (para fallback cuando SRP no tiene imagen)
                if (prod.itemData && prod.itemData.imagePlanogramFront && !prod.itemData._individualImagePlanogramFront) {
                  prod.itemData._individualImagePlanogramFront = prod.itemData.imagePlanogramFront;
                }

                // Preservar exhibitionTypeId de unitOfExhibition
                if (prod.unitOfExhibition.exhibitionTypeId != null) {
                  prod.exhibitionTypeId = prod.unitOfExhibition.exhibitionTypeId;
                }

                // Actualizar dimensiones con los datos de unitOfExhibition
                prod.itemData.size = prod.itemData.size || {};
                if (prod.unitOfExhibition.width != null) {
                  prod.itemData.size.w = prod.unitOfExhibition.width;
                }
                if (prod.unitOfExhibition.height != null) {
                  prod.itemData.size.h = prod.unitOfExhibition.height;
                }
                if (prod.unitOfExhibition.depth != null) {
                  prod.itemData.size.d = prod.unitOfExhibition.depth;
                }

                // Actualizar imagen con la de unitOfExhibition
                if (prod.unitOfExhibition.imagePlanogramFront) {
                  prod.itemData.imagePlanogramFront = prod.unitOfExhibition.imagePlanogramFront;
                } else {
                  // Si SRP no trae imagen, mantener la individual (no la pises)
                  prod.itemData.imagePlanogramFront =
                    prod.itemData._individualImagePlanogramFront || prod.itemData.imagePlanogramFront || null;
                }

                // Actualizar también las dimensiones directas en itemData para consistencia
                if (prod.unitOfExhibition.width != null) {
                  prod.itemData.width = prod.unitOfExhibition.width;
                }
                if (prod.unitOfExhibition.height != null) {
                  prod.itemData.height = prod.unitOfExhibition.height;
                }
                if (prod.unitOfExhibition.depth != null) {
                  prod.itemData.depth = prod.unitOfExhibition.depth;
                }
              } else {
                // Si no tiene unitOfExhibition, preservar exhibitionTypeId del servidor al prod para que se mantenga al guardar
                if (prod.exhibitionTypeId != null) {
                  // Ya está en el prod, mantenerlo
                } else if (prod.itemData?.exhibitionUnit?.exhibitionTypeId != null) {
                  prod.exhibitionTypeId = prod.itemData.exhibitionUnit.exhibitionTypeId;
                } else if (prod.itemData?.exhibitionTypeId != null) {
                  prod.exhibitionTypeId = prod.itemData.exhibitionTypeId;
                }

                // Si el producto tiene exhibitionFormats, aplicar el formato activo (persistido o legacy SRP)
                if (
                  prod.itemData.exhibitionFormats &&
                  Array.isArray(prod.itemData.exhibitionFormats) &&
                  prod.itemData.exhibitionFormats.length > 0
                ) {
                  const activeTypeId = _resolveActiveExhibitionTypeId(prod);
                  if (activeTypeId != null) {
                    if (prod.exhibitionTypeId == null) {
                      prod.exhibitionTypeId = activeTypeId;
                    }
                    _applyExhibitionFormatToItemData(prod.itemData, activeTypeId);
                  }
                }
              }

              if (prod.itemData.size) prod.itemData.size.d = prod.itemData.size.d || prod.itemData.size.w;
              if (prod.itemData.canRotate != undefined) prod.itemData.cantRotate = !prod.itemData.canRotate;
              prod.itemData.canRotateY = prod.itemData.canRotateY != null ? prod.itemData.canRotateY : true;

              if (shelf.type === 'normalShelf-level') delete prod.position;

              delete prod.size;
              delete prod.width;
              delete prod.height;

              //2v5gkb / para testear con precio 0
              if (_isDev() && TEST_PRICE_ZERO) {
                prod.itemData.storesInfo = prod.itemData.storesInfo.map(el => {
                  return { ...el, price: 0 };
                });
              }

              //DES-5001
              if (false && _isDev()) {
                prod.itemData.ean = null;
              }

              // CATMAN-B019: ids únicos en preview (BE manda id:0 para todos los prods del estante).
              if (featureFlagScope) {
                const skuId = prod.itemData?.itemId ?? prod.itemId ?? 0;
                const uom = prod.itemData?.unitOfMeasureId ?? prod.unitOfMeasureId ?? 0;
                prod.id = `${prod.order ?? 0}-${skuId}-${uom}`;
              }

              _addInternalObjId(prod, PROD_ID_PREFIX);
              _addInternalCode(prod?.itemData);

              // Propagar isFixedEmptySpace del prod al itemData (backend -> frontend)
              const isFixedEmptySpace = !!(prod.isFixedEmptySpace || Number(prod.itemId) === -2 || Number(prod.itemData?.itemId) === -2);
              if (isFixedEmptySpace && prod.itemData) {
                prod.isFixedEmptySpace = true;
                prod.itemData.isFixedEmptySpace = true;
                prod.itemData.isEmptySpace = true;
                prod.itemData.itemId = -2;
                if (!prod.itemData.code) prod.itemData.code = 'FixedEmptySpace';

                // Para edición/render: asegurar campos de espacio fijo en el objeto de estante.
                prod.fixedX = Number(prod.fixedX ?? 0);
                prod.fixedWidth = Number(prod.fixedWidth ?? prod.facings ?? 1);
              }

              //DES-1501
              if (!prod.facings || prod.facings < 1) prod.facings = 1;

              //CAT-19
              let isEmptySpace = prod.itemData?.isEmptySpace;

              return _auxTransformInputData_genericTransform(prod);
            });

          if (shelf.type !== 'pitShelf-level' && !$planogram?.structureOnly && shelf.depth == null) delete shelf.depth;
          delete shelf.position;
          delete shelf.width;

          //DES-1576
          shelf.marginLeft = shelf.marginLeft || 0;
          shelf.marginRight = shelf.marginRight || 0;

          // Mapear noValidateSize del backend a __shelfAvoidCheckSpace en el frontend
          if (shelf.noValidateSize != null) {
            shelf.__shelfAvoidCheckSpace = !!shelf.noValidateSize;
            delete shelf.noValidateSize;
          }

          _addInternalObjId(shelf, SHELF_ID_PREFIX);
          return _auxTransformInputData_genericTransform(shelf);
        });

      delete mod.position;
      delete mod.doorType;
      delete mod.height;

      _addInternalObjId(mod, MOD_ID_PREFIX);
      return _auxTransformInputData_genericTransform(mod);
    });

  obj.floats = (obj.floats || []).map((float, $i) => {
    if (float) {
      let i = $i + 1;

      float.prods = (
        float.prods?.length > 0
          ? float.prods
          : [
              {
                itemId: i,
                unitOfMeasureId: i,
                offsetY: 0,
                itemData: {
                  itemId: i,
                  unitOfMeasureId: i,
                  imagePlanogramFront: float.imageUrl,
                  width: float.width,
                  height: float.height,
                  size: {
                    w: float.width,
                    h: float.height,
                    d: 10,
                  },
                },
              },
            ]
      )
        .filter(p => !!(p && p.itemData && p.itemData.itemId && p.itemData.size && p.itemData.size.w))
        .map(prod => {
          prod.itemData._internalItemId = _set_internalItemId(prod.itemData.itemId, prod.itemData.unitOfMeasureId);
          _addInternalObjId(prod, PROD_POP_ID_PREFIX);
          _addInternalCode(prod?.itemData);
          return _auxTransformInputData_genericTransform(prod);
        });
    }

    _addInternalObjId(float, FLOAT_ID_PREFIX);
    return _auxTransformInputData_genericTransform(float);
  });

  obj.publishedDate = new Date(obj.publishedDate || obj.publishDate || new Date());

  obj.description = obj.planogramDescription || '';
  delete obj.planogramDescription;

  obj.planogramType = 'Planogram';

  if ($planogram?.structureOnly) obj.planogramType = 'Structure';
  if ($planogram?.isGenericSpace) obj.planogramType = 'GenericSpace';

  if (featureFlagScope) {
    const itemscopeFromBe: FormModel_scopeItems = _pick(
      obj?.itemScope || {
        itemIds: [],
        selectionType: 1,
        genericCategorysSelection: {
          categorys: [],
          categorysExcluded: [],
          subCategorys: [],
          subCategorysExcluded: [],
        },
        tagValueIdsToInclude: [],
        tagValueIdsToExclude: [],
        onlyItemsAllowedForSelling: true,
      },
      ScopeItems_KEYS
    );
    const itemScope = mapItemScopeFromBE(itemscopeFromBe);
    obj.itemScope = itemScope;
  }

  obj.promotionMaterial = $planogram?.promotionMaterial || [];
  obj.imageUrl = $planogram?.imageUrl || '';
  obj.width = $planogram?.width || null;
  obj.height = $planogram?.height || null;
  obj.depth = $planogram?.depth || null;

  return _auxTransformInputData_genericTransform(obj);
};

export const _auxTransValidTimeLine = $planograms => {
  if (!$planograms) return [];

  const CHECK_DIFF_DAY = true;

  let _lastDate = null;
  let _lastPlanogram = null;
  let rv = [];

  $planograms.forEach(pog => {
    let isOk = pog && pog.modules && pog.modules.length && pog.publishDate;
    let date = new Date(pog.publishDate);

    if (CHECK_DIFF_DAY && isOk && _lastDate) {
      let diffDays = Math.abs(Math.ceil(date.getTime() - _lastDate.getTime()) / (1000 * 60 * 60 * 24));

      // Si el nuevo planogram es de un día diferente, guarda el último planogram del día anterior
      if (diffDays >= 1) {
        if (_lastPlanogram) {
          rv.push(_lastPlanogram);
        }
        _lastPlanogram = pog;
        _lastDate = date;
      } else {
        // Si es del mismo día, solo guarda el planogram con la fecha más reciente
        if (date > _lastDate) {
          _lastPlanogram = pog;
          _lastDate = date;
        }
      }
    } else if (isOk) {
      _lastPlanogram = pog; // Actualiza el último planogram si es válido
      _lastDate = date;
    }

    if (!isOk) console.error('[timeline without modules]', pog);
  });

  // Al final, agrega el último planogram válido (del último día)
  if (_lastPlanogram) {
    rv.push(_lastPlanogram);
  }

  return rv;
};

export const _auxTransformInputListProdsData = data => {
  data.items
    ? (data.items = data.items.map(i => {
        _addInternalCode(i);

        // Si el producto tiene exhibitionFormats, usar los datos del exhibitionTypeId === 2 (SRP)
        let dimensions = i.size;
        let imagePlanogramFront = i.imagePlanogramFront;

        if (i.exhibitionFormats && Array.isArray(i.exhibitionFormats) && i.exhibitionFormats.length > 0) {
          // Preservar imagen individual antes de sobreescribir visualización para SRP.
          const individualImage = i.imagePlanogramFront || null;
          const srpFormat = i.exhibitionFormats.find(format => format.exhibitionTypeId === 2);

          if (srpFormat) {
            // Usar dimensiones del formato SRP
            dimensions = {
              width: srpFormat.width,
              height: srpFormat.height,
              depth: srpFormat.depth,
            };

            // Usar imagen del formato SRP si está disponible
            if (srpFormat.imagePlanogramFront) {
              imagePlanogramFront = srpFormat.imagePlanogramFront;
            }

            // Guardar respaldo explícito para opción "Individual" cuando backend responde solo SRP.
            i._individualImagePlanogramFront = individualImage;
            i.originalImagePlanogramFront = individualImage;
          }
        }

        return {
          ...i,
          imagePlanogramFront,
          size: dimensions
            ? {
                w: _round(dimensions.width || dimensions.w),
                h: _round(dimensions.height || dimensions.h),
                d: _round(dimensions.depth || dimensions.d || dimensions.width || dimensions.w),
              }
            : { w: 0, h: 0, d: 0 },
        };
      }))
    : data;

  data.items = _auxReduceProdsStoresInfo(data.items) || [];

  if (_isDev() && TEST_PRICE_ZERO) {
    data.items = data.items.map(i => {
      i.storesInfo = (i.storesInfo || []).map(el => {
        return { ...el, price: 0 };
      });
      if (i.price) i.price = 0;
      return i;
    });
  }

  if (data.totalItemCount != undefined) data.totalItems = data.totalItemCount || 0;

  return data;
};

export const _auxTransformInputListPopData = $data => {
  let data = _cloneDeep($data);

  if (data?.items?.length > 0) {
    data.items = (data.items || []).map(items => {
      items.prods = (items?.prods || []).map(prod => {
        if (prod.itemData) _addInternalCode(prod.itemData);
        return prod;
      });
      return items;
    });
  }

  return data;
};

const _auxTransformInputData_genericTransform = _obj => {
  Object.entries(_obj).forEach(([key, value]) => {
    //Borra las props que comienzan con $
    if (key[0] === '$') {
      delete _obj[key];
    }

    //Borra las props que son dataCalculada
    if (key.indexOf('CALC_') === 0 || key.indexOf('calc_') === 0) {
      delete _obj[key];
    }

    if (false) delete _obj.order;
  });
  return _obj;
};

/*
    Trasnformaciones para save
    OUTPUT
*/
export const _auxTransformOutputPlanogramData = ($planogram, calcDataMod, featureFlagScope = false) => {
  let planogram = _clonePlanogram($planogram);

  delete planogram._viewType;
  delete planogram.stageSize;
  delete planogram.state;
  delete planogram.publishedDate;
  delete planogram.publishDate;
  delete planogram.status;

  planogram.planogramDescription = planogram.description || '';
  delete planogram.description;

  if (!planogram.id) planogram.id = 0;

  const isStructure = planogram.planogramType === 'Structure';
  const isGenericSpace = planogram.planogramType === 'GenericSpace';

  planogram.structureOnly = isStructure;
  planogram.isGenericSpace = isGenericSpace;

  delete planogram.planogramType;

  if (calcDataMod) {
    if (false) _log('\n[calcDataMod]', calcDataMod, '\n');
    //DES-1451 Redondeo de cálculos
    planogram.CALC_totalLineSpace = Math.round(calcDataMod.shelfs_totalLineSpace || 0);
    planogram.CALC_totalItems = Math.round(calcDataMod.totalItems || 0);
    planogram.CALC_totalFacings = Math.round(calcDataMod.totalFacings || 0);
  } else {
    _warn('NO calcDataMod', calcDataMod);
  }

  if (!featureFlagScope) {
    planogram.categoriesSelected = _array2plainId(planogram.categoriesSelected);
    if (isStructure) planogram.categoriesSelected = [];
  } else {
    //TODO para cuando se quite el feature flag hay que eliminar esta prop de modelo store html del general
    //    🔥 Ojo: Hay que definir con BE como se va a cambiar este tema pq si esta prop no viaja, así como esta hoy pincha
    //            esto fue lo que produjo hacer el rollBack del FF DES-2998 y hacer el fix CAT-588
    //            hay un enforzado en el servicio, ver: id:z_cPCzaDNc
    if (false) delete planogram.categoriesSelected; //CAT-602 - CAT-588
  }

  planogram.storesSelected = _array2plainId(planogram.storesSelected);

  planogram.floats = isStructure
    ? []
    : (planogram.floats || []).map(float => {
        delete float.prods;
        delete float.name;
        delete float.image;

        float.idFloatRef = float.idFloatRef;

        _removeInternalObjId(float, FLOAT_ID_PREFIX);
        return _auxTransformOutputData_genericTransform(float);
      });

  planogram.textAnnotations = isStructure
    ? []
    : (planogram.textAnnotations || []).map(annotation => {
        annotation.content = (annotation.content || '').slice(0, 500);
        if (typeof annotation.id === 'string') annotation.id = 0;
        annotation.planogramId = planogram.id || 0;
        return _auxTransformOutputData_genericTransform(annotation);
      });

  planogram.modules = (planogram.modules || []).map(mod => {
    mod = _auxTransformOutputData_modTransform(mod);
    mod.shelfs = (mod.shelfs || []).map(shelf => {
      shelf = _auxTransformOutputData_shelfTransform(shelf, isStructure);
      shelf.prods = isStructure
        ? []
        : (shelf.prods || []).map(prod => {
            prod = _auxTransformOutputData_prodTransform(prod, shelf.type);
            return prod;
          });

      return shelf;
    });
    return mod;
  });
  if (featureFlagScope) {
    const $itemScope = mapItemScopeToBE(planogram, true, undefined, true);
    let itemScope: FormModel_scopeItems = _pick($itemScope || {}, ScopeItems_KEYS);
    itemScope.onlyItemsAllowedForSelling = true;
    planogram.itemScope = itemScope;
  }

  planogram.constraints = _reset_getNewNumberId(planogram.constraints, 'id');
  if (isStructure) delete planogram.constraints;

  planogram.imageUrl = $planogram.imageUrl;

  return _auxTransformOutputData_genericTransform(planogram);
};

const _auxTransformOutputData_genericTransform = _obj => {
  Object.entries(_obj).forEach(([key, value]) => {
    //Borra las props que comienzan con underscore

    //Solo se guardan los CALC_ no calc_
    if (key.indexOf('calc_') === 0) {
      delete _obj[key];
    }

    //Tranforma el prefix de $
    if (key[0] === '$') {
      _obj['CALC_' + key.substring(1)] = _cloneDeep(value);
      delete _obj[key];
    }

    if (key[0] === '_') {
      delete _obj[key];
    }

    if (key.indexOf('$parenShelf') !== -1) {
      delete _obj['CALC_' + key.substring(1)];
      delete _obj[key];
    }

    //Resetea IDs internos
    if ((key === 'id' || key === 'idFloatRef') && typeof value === 'string') {
      _obj[key] = 0;
    }

    //Resetea si es id negativo
    if ((key === 'id' || key === 'idFloatRef') && String(value)[0] === '-') {
      _obj[key] = 0;
    }
  });

  return _obj;
};

const _auxTransformOutputData_modTransform = _mod => {
  if (!_mod.id) _mod.id = 0;

  if (_mod.boxData) {
    delete _mod.boxData.position;
    delete _mod.boxData.size;
  }

  delete _mod.bottomData;
  delete _mod.offsetBox;
  delete _mod.offsetShelf;

  _removeInternalObjId(_mod, MOD_ID_PREFIX);
  return _auxTransformOutputData_genericTransform(_mod);
};

const _auxTransformOutputData_shelfTransform = (_shelf, keepDepth = false) => {
  //Si tiene prefijo se lo saca

  if (!_shelf.id) _shelf.id = 0;

  delete _shelf.width;
  delete _shelf.position;

  //DES-1576
  _shelf.marginLeft = _shelf.marginLeft || 0;
  _shelf.marginRight = _shelf.marginRight || 0;

  if (!keepDepth && _shelf.type !== 'pitShelf-level' && _shelf.depth == null) delete _shelf.depth;

  // Mapear __shelfAvoidCheckSpace del frontend a noValidateSize para el backend
  if (_shelf.__shelfAvoidCheckSpace != null) {
    _shelf.noValidateSize = !!_shelf.__shelfAvoidCheckSpace;
  }

  _removeInternalObjId(_shelf, SHELF_ID_PREFIX);
  return _auxTransformOutputData_genericTransform(_shelf);
};

export const _auxTransformOutputData_prodTransform = (_prod, _shelType) => {
  if (!_prod.id) _prod.id = 0;

  if (_shelType === 'normalShelf-level') {
    delete _prod.position;
  }

  _prod.itemId = _prod.itemData?.itemId ?? _prod.itemId;
  _prod.unitOfMeasureId = _prod.itemData?.unitOfMeasureId ?? _prod.unitOfMeasureId;

  const isFixedEmptySpace = !!(_prod.isFixedEmptySpace || _prod.itemData?.isFixedEmptySpace);
  const isEmptySpace = !!(_prod.itemData?.isEmptySpace || _prod.isEmptySpace || isFixedEmptySpace);

  // Asegura que los espacios vacíos viajen con IDs esperados por backend.
  if (isFixedEmptySpace) {
    _prod.itemId = -2;
    _prod.fixedX = Number(_prod.fixedX ?? 0);
    _prod.fixedWidth = Number(_prod.fixedWidth ?? _prod.facings ?? 1);
  } else if (isEmptySpace && _prod.itemId == null) {
    _prod.itemId = -1;
  }

  // Preservar exhibitionTypeId antes de eliminar itemData
  // Buscar en múltiples ubicaciones posibles
  if (_prod.exhibitionTypeId != null) {
    // Ya está en el prod, mantenerlo
  } else if (_prod.itemData?.exhibitionUnit?.exhibitionTypeId != null) {
    _prod.exhibitionTypeId = _prod.itemData.exhibitionUnit.exhibitionTypeId;
  } else if (_prod.itemData?.exhibitionTypeId != null) {
    _prod.exhibitionTypeId = _prod.itemData.exhibitionTypeId;
  } else if (
    _prod.itemData?.exhibitionFormats &&
    Array.isArray(_prod.itemData.exhibitionFormats) &&
    _prod.itemData.exhibitionFormats.length > 0
  ) {
    const activeTypeId = _resolveActiveExhibitionTypeId(_prod);
    if (activeTypeId != null) {
      _prod.exhibitionTypeId = activeTypeId;
    }
  }

  //Defaults
  _prod.rotation = _prod.rotation || 0;
  _prod.stacksLyingDown = _prod.stacksLyingDown || false;

  //DataCalc
  _prod.$stacks = _prod.stacks || 1;
  _prod.$totalWidth = _prod.$totalWidth || _get(_prod, 'size.w') || 0;

  if (_shelType === 'float-pop-impulse-strip-simple') {
    delete _prod.id;
    delete _prod.$stacks;
    delete _prod.$totalWidth;
    delete _prod.rotation;
    delete _prod.stacksLyingDown;
  }

  //Delete
  delete _prod.itemData;
  delete _prod.stacks;
  delete _prod.groupImgItems;
  delete _prod.size;
  delete _prod.imgSize;
  delete _prod.isList;
  delete _prod._internalItemId;

  _removeInternalObjId(_prod, PROD_ID_PREFIX);
  _removeInternalObjId(_prod, PROD_POP_ID_PREFIX);

  //DES-1501
  if (!_prod.facings || _prod.facings < 1) _prod.facings = 1;

  return _auxTransformOutputData_genericTransform(_cloneDeep(_prod));
};

const _ScopeItems_KEYS: FormModel_scopeItems | any = {
  itemIds: null,
  categoryIdsToInclude: null,
  categoryIdsToExclude: null,
  tagValueIdsToInclude: null,
  tagValueIdsToExclude: null,
  itemIdsToExclude: null,
  onlyItemsAllowedForSelling: null,
};
const ScopeItems_KEYS = Object.keys(_ScopeItems_KEYS);
